/*
 * @Description: 门店
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2023-03-27 16:20:43
 * @LastEditTime: 2023-03-28 18:09:30
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 分类列表
  cateList (querys) {
    return get('store/admin/AdminStore/cateList', querys)
  },
  // 分类下拉框
  cateSelect (querys) {
    return get('store/admin/AdminStore/cateSelect', querys)
  },
  // 分类详情
  cateInfo (querys) {
    return get('store/admin/AdminStore/cateInfo', querys)
  },
  // 新增分类
  cateAdd (querys) {
    return post('store/admin/AdminStore/cateAdd', querys)
  },
  // 编辑分类
  cateUpdate (querys) {
    return post('store/admin/AdminStore/cateUpdate', querys)
  },
  // 门店列表
  storeList (querys) {
    return get('store/admin/AdminStore/storeList', querys)
  },
  // 门店下拉框
  storeSelect (querys) {
    return get('store/admin/AdminStore/storeSelect', querys)
  },
  // 门店详情
  storeInfo (querys) {
    return get('store/admin/AdminStore/storeInfo', querys)
  },
  // 新增门店
  storeAdd (querys) {
    return post('store/admin/AdminStore/storeAdd', querys)
  },
  // 编辑门店
  storeUpdate (querys) {
    return post('store/admin/AdminStore/storeUpdate', querys)
  },
  // 动态审核
  storeCheck (querys) {
    return post('store/admin/AdminStoreList/storeCheck', querys)
  },
  // 删除动态
  storeDel (querys) {
    return post('store/admin/AdminStoreList/storeDel', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/store.js